import { mkQcsSyncResourceStore } from 'data/qcsSyncResourceTypes';
import { handleActions } from 'redux-actions';
import { upsertResources, completeWithError } from 'data/qcsSyncResourceReducerHelpers';

import * as actions from './investmentPerformanceV2Actions';

const investmentPerformanceV2Reducer = handleActions({

  [actions.getInvestmentPerformanceV2]:
    (state) => state.merge({ isLoading: true }),
  [actions.getInvestmentPerformanceV2Success]:
    (state, action) => upsertResources(state, action.payload),
  [actions.getInvestmentPerformanceV2Failure]:
    (state, { payload: error }) => completeWithError(state, error),

}, mkQcsSyncResourceStore());

export const INVESTMENT_PERFORMANCE_V2_REDUCER_KEY = 'investmentPerformanceV2Store';
export default investmentPerformanceV2Reducer;
